module.exports = "<div class=\"container\">\n\t\n\t<h1>\n  new service works!\n</h1>\n<form [formGroup]=\"form\">\n      <formly-form [model]=\"model\" [fields]=\"fields\">\n        <button type=\"submit\" class=\"btn btn-default\" (click)=set()>Submit</button>\n      </formly-form>\n    </form>\n    {{ model | json }}\n    <br>\n    ------------------\n    {{ response | json }}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/sachinmacbook/Sites/ngfront/src/app/new-service/new-service.component.html
// module id = ../../../../../src/app/new-service/new-service.component.html
// module chunks = main